export const SET_TOKEN = 'SET_TOKEN'
export const SET_LAYOUT = 'SET_LAYOUT'
